import React, { Component } from 'react'
import { Map, List, fromJS } from 'immutable'
import { connect as connectRedux } from 'react-redux'
import FormsyForm from 'formsy-react'
import { getBoundActions } from '../../../actions/index'
import Button, { TYPES } from '../../Button/index'
import { H4 } from '../../Heading/index'
import { getPrimary } from '../../../services/languages/index'
import { Card, STATES } from '../../Card/index'
import Expandable from '../../Expandable/Expandable'
import {
  PRIMARY_LANGUAGE_CHANGED_GA4_EVENT,
  SECONDARY_LANGUAGE_CHANGED_GA4_EVENT,
} from '../../../services/event-tracking/index'
import { Checkbox, Radio, RadioGroup } from '../../FormInput.v2/index'
import { LANGUAGE_SETTINGS } from '../../../services/url/constants'

const LANGUAGE_PRIMARY_CLASS = [
  'language-primary-select',
]

const LANGUAGE_SECONDARY_CLASS = [
  'language-secondary-select__checkbox-input',
]

const getContentLanguagesLabel = (model) => {
  const selectedLangs = []
  const languages = ['de', 'en', 'es', 'fr']
  languages.forEach((lang) => {
    if (model[lang]) selectedLangs.push(lang)
  })
  return selectedLangs
}

class LanguageSettings extends Component {
  //
  constructor (props) {
    super(props)
    this.state = {}
  }

  onPrimaryLanguageSelect = (name, value) => {
    this.setState(() => ({
      primaryLanguage: value,
    }))
  }

  handleLanguageSubmit = (model) => {
    const { props } = this
    const { setUserDataLanguage, setFeatureTrackingDataPersistent } = props
    const data = fromJS(model)
    const primary = data.get('primaryLanguage', 'en')
    const secondary = data.delete('primaryLanguage')
    const languages = secondary.reduce((list, val, key) => {
      if (val && !list.includes(key)) return list.push(key)
      return list
    }, List([primary]))

    setUserDataLanguage(languages)
    setFeatureTrackingDataPersistent({
      data: Map({ userLanguages: languages }),
    })
  }

  renderLanguageDisplay () {
    const { props } = this
    const { featureTrackingLanguages, staticText, userLanguages } = props
    const selectedPrimaryLang = staticText.getIn(['data', `${getPrimary(userLanguages)}`])
    const secondaryLangDisplays = featureTrackingLanguages.map((lang) => (
      staticText.getIn(['data', lang])
    )).join(', ')

    return (
      <div className="language-select-box__flex">
        <div className="language-select-box__section-left">
          <H4>{staticText.getIn(['data', 'primarySubhead'])}</H4>
          {selectedPrimaryLang}
        </div>
        <div className="language-select-box__section-left">
          <H4>{staticText.getIn(['data', 'secondarySubhead'])}</H4>
          {secondaryLangDisplays}
        </div>
      </div>
    )
  }

  renderLanguageEditMode (cancelEdit) {
    const { props, state } = this
    const { primaryLanguage: statePrimaryLanguage } = state
    const {
      staticText,
      languages,
      userLanguages,
      featureTrackingLanguages,
      setEventDefault,
    } = props
    const primaryLanguage = statePrimaryLanguage || userLanguages.get(0, 'en')
    return (
      <FormsyForm
        className="language-select-box__form"
        onSubmit={(model) => {
          this.handleLanguageSubmit(model)
          const contentSiteLanguages = getContentLanguagesLabel(model)

          // GA4 events
          const uiLocation = 'Settings'
          const primaryLanguageEventData = PRIMARY_LANGUAGE_CHANGED_GA4_EVENT
            .mergeDeep({
              changed_to: model.primaryLanguage,
              ui_element: 'Settings',
              ui_location: uiLocation,
            })
          const secondaryLanguageEventData = SECONDARY_LANGUAGE_CHANGED_GA4_EVENT
            .mergeDeep({
              changed_to: contentSiteLanguages.join(', '),
              ui_element: 'Settings',
              ui_location: uiLocation,
            })

          setEventDefault(primaryLanguageEventData)
          setEventDefault(secondaryLanguageEventData)

          cancelEdit()
        }}
      >
        <div className="language-select-box__lang-container-outer">
          <div className="language-select-box__lang-container">
            <H4>{staticText.getIn(['data', 'primarySubhead'])}</H4>
            {staticText.getIn(['data', 'primaryBody'])}
            <div className="language-select-box__lang-checkboxes">
              <RadioGroup
                value={primaryLanguage}
                name="primaryLanguage"
                onChange={this.onPrimaryLanguageSelect}
              >
                {languages.map((lang) => {
                  const value = lang.get('value')
                  return (
                    <Radio
                      className={LANGUAGE_PRIMARY_CLASS}
                      key={`form-input__radio--${value}`}
                      label={lang.get('label')}
                      value={value}
                      name={value}
                      checked={value === primaryLanguage}
                    />
                  )
                })}
              </RadioGroup>
            </div>
          </div>
          <div className="language-select-box__lang-container">
            <H4>{staticText.getIn(['data', 'secondarySubhead'])}</H4>
            {staticText.getIn(['data', 'secondaryBody'])}
            <div className="language-select-box__lang-checkboxes">
              {languages.map((lang) => {
                const value = lang.get('value')
                const primary = value === primaryLanguage
                const selected = primary || featureTrackingLanguages.includes(value)
                return (
                  <Checkbox
                    className={LANGUAGE_SECONDARY_CLASS}
                    key={`form-input__radio--${value}`}
                    label={lang.get('label')}
                    checkedValue={value}
                    disabled={primary}
                    value={selected}
                    name={value}
                  />
                )
              })}
            </div>
          </div>
        </div>
        <div className="my-account-settings__language-buttons">
          <div className="my-account-settings__language-btn">
            <Button
              type={TYPES.PRIMARY}
              submit
              className="my-account-settings__email-save"
            >
              {staticText.getIn(['data', 'save'])}
            </Button>
          </div>
          <div className="my-account-settings__language-btn">
            <Button
              type={TYPES.GHOST}
              onClick={() => {
                cancelEdit()
                this.setState(() => ({
                  primaryLanguage: null,
                }))
              }}
              className="my-account-settings__email-cancel"
            >
              {staticText.getIn(['data', 'cancel'])}
            </Button>
          </div>
        </div>
      </FormsyForm>
    )
  }

  renderLanguageSettings () {
    return (
      <div className="language-select-box">
        <Card editable>
          {(editState, toggleState) => (
            editState === STATES.DISPLAY
              ? this.renderLanguageDisplay()
              : this.renderLanguageEditMode(toggleState)
          )}
        </Card>
      </div>
    )
  }

  render () {
    const { props } = this
    const { staticTextV2 } = props
    return (
      <Expandable
        id={LANGUAGE_SETTINGS}
        className="my-account-settings-V2__settings-container"
        variant="setting"
        header={staticTextV2.getIn(['data', 'languageSettings'])}
        description={staticTextV2.getIn(['data', 'languageSettingsDescription'])}
      >
        {this.renderLanguageSettings()}
      </Expandable>
    )
  }
}

export default connectRedux(
  (state) => ({
    languages: state.languages.get('data', List()),
    userLanguages: state.user.getIn(['data', 'language'], List()),
    staticText: state.staticText.getIn(['data', 'myAccountSettings'], Map()),
    staticTextV2: state.staticText.getIn(['data', 'myAccountSettingsV2'], Map()),
    featureTrackingLanguages: state.featureTracking.getIn(['data', 'userLanguages'], List()),
  }),
  (dispatch) => {
    const actions = getBoundActions(dispatch)
    return {
      setUserDataLanguage: actions.user.setUserDataLanguage,
      setFeatureTrackingDataPersistent: actions.featureTracking.setFeatureTrackingDataPersistent,
      setEventDefault: actions.eventTracking.setEventDefault,
    }
  },
)(LanguageSettings)
